import React from 'react'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import columns, { ColumnTitleWithTooltip } from '../../UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { ITableColumnsType } from 'uikit/tables/default'

export const cryptoColumns: ITableColumnsType<any> = [
  {
    ...columns[COLUMNS_IDS.profileNames],
    title: <ColumnTitleWithTooltip title='Online Name' tooltipText='Names used by entity/individual online' />,
  },
  { ...columns[COLUMNS_IDS.verifiedName], minWidth: 150 },
  columns[COLUMNS_IDS.tin],
  columns[COLUMNS_IDS.reportStatus],
  columns[COLUMNS_IDS.unreportedRevenue],
  columns[COLUMNS_IDS.reported],
  columns[COLUMNS_IDS.totalInflowsUsd],
  columns[COLUMNS_IDS.totalOutflowsUsd],
  columns[COLUMNS_IDS.maxAnnualGain],
  columns[COLUMNS_IDS.totalNFTMintsUsd],
  columns[COLUMNS_IDS.totalMintRevenue],
  columns[COLUMNS_IDS.totalRevenue],
  columns[COLUMNS_IDS.totalRoyalties],
  columns[COLUMNS_IDS.dataSources],
  columns[COLUMNS_IDS.activityType],
  columns[COLUMNS_IDS.firstActivity],
  columns[COLUMNS_IDS.caseId],
  columns[COLUMNS_IDS.locations],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  cryptoColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
